/**
 * Checks if the current rendering device has a touch screen.
 */
export function isTouchableDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

/**
 * Show the browser (body) in fullscreen mode
 *
 */
export function requestFullScreenMode() {
  //different versions are necessary to work on ipad/safari https://web.dev/native-hardware-fullscreen/
  const docEl = document.body;
  const requestMethod =
    docEl.requestFullscreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    docEl.mozRequestFullScreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    docEl.webkitRequestFullScreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    docEl.msRequestFullscreen;

  if (requestMethod) {
    requestMethod.apply(docEl);
  }
}

/**
 * Exit fullscreen mode of the browser
 *
 */
export function exitFullScreenMode() {
  //different versions are necessary to work on ipad/safari https://web.dev/native-hardware-fullscreen/
  const doc = window.document;
  const cancelFullScreen =
    doc.exitFullscreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    doc.mozCancelFullScreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    doc.webkitExitFullscreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    doc.msExitFullscreen;
  cancelFullScreen.call(doc);
}

/**
 * Calculates the font-size scaling based on the `#content` element's computed font-size.
 */
export function getFontScale(): number {
  // TODO: make it so this method works for the storybook as well.
  const rootEl = window.document.getElementById('content');
  if (rootEl) {
    const fontSize = parseFloat(getComputedStyle(rootEl).fontSize);
    return fontSize / 14;
  } else {
    return 1; // should normally never happen
  }
}

export function isSafari() {
  const ua = navigator.userAgent;
  return (
    /Safari/.test(ua) &&
    !/Chrome/.test(ua) &&
    !/CriOS/.test(ua) &&
    !/FxiOS/.test(ua) &&
    !/Edg/.test(ua)
  );
}

export function isMobileDevice(): boolean {
  const ua = navigator.userAgent;
  return /Android|iPhone|iPad|iPod/.test(ua);
}
